import { render, staticRenderFns } from "./solution-categories.vue?vue&type=template&id=4c74debe&scoped=true"
import script from "./solution-categories.vue?vue&type=script&lang=js"
export * from "./solution-categories.vue?vue&type=script&lang=js"
import style0 from "./solution-categories.vue?vue&type=style&index=0&id=4c74debe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c74debe",
  null
  
)

export default component.exports